import React, { useEffect, useState } from 'react';
import { Center } from '@react-three/drei';
import { EquirectangularReflectionMapping } from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { useThree } from '@react-three/fiber';
import { ErrorBoundary } from 'react-error-boundary';
import ModelLoadingError from './ModelLoadingError';
import Tamotsu from './models/Tamotsu';
import Metabiotic10ml from './models/Metabiotic10ml';
import CodLiverOil from './models/CodLiverOil';
import Dent from './models/Dent';
import Metabiotic from './models/Metabiotic';
import MetabioticLux from './models/MetabioticLux';
import Shampoo from './models/Shampoo';
import Case from './models/Case';

type Props = {
    modelName: string;
    onLoad?: () => void;
};

const DICT = {
    tamotsu: Tamotsu,
    'сod-liver-oil': CodLiverOil,
    dent: Dent,
    metabiotic: Metabiotic,
    'metabiotic-10-ml': Metabiotic10ml,
    'metabiotic-lux': MetabioticLux,
    shampoo: Shampoo,
    case: Case,
} as const;

const Product = ({ modelName, onLoad }: Props) => {
    const [name, setName] = useState(modelName);
    const [textureLoaded, setTextureLoaded] = useState(false);
    const Component = (DICT as any)[name];
    const scene = useThree((state) => state.scene);
    const scale = matchMedia('(max-width: 1024px)').matches ? 0.7 : 1;

    useEffect(() => {
        const t = new RGBELoader().load(
            '/local/templates/main/static/img/textures/photo_studio_01_1k.hdr',
            (texture) => {
                texture.mapping = EquirectangularReflectionMapping;
                scene.environment = texture;
                setTextureLoaded(true);
                onLoad?.();
            },
        );

        return () => {
            t.dispose();
        };
    }, []);

    useEffect(() => {
        const onModelChange = (event: any) => {
            setName(event.detail.name);
        };

        document.addEventListener('product-model-change', onModelChange);

        return () => {
            document.removeEventListener('product-model-change', onModelChange);
        };
    }, []);

    return Component ? (
        textureLoaded ? (
            <ErrorBoundary fallback={<ModelLoadingError message="Произошла ошибка" />}>
                {name === 'case' ? (
                    <Component scale={[scale, scale, scale]} />
                ) : (
                    <Center>
                        <Component scale={[scale, scale, scale]} />
                    </Center>
                )}
            </ErrorBoundary>
        ) : null
    ) : (
        <ModelLoadingError message="Не удалось загрузить модель. Неправильно указано имя модели" />
    );
};

export default Product;
